import {ChangeDetectorRef, Component} from '@angular/core';
import {AuditlogService} from "../../services/auditlog.service";
import {AbstractProdGrid, IProdGrid, ProdGridColumnTransforms, ProdGridColumnType} from 'prod-grid';
import {DipColumn} from "../../dip/dip-column";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-auditlog',
  templateUrl: './auditlog.component.html',
})
export class AuditlogComponent extends AbstractProdGrid implements IProdGrid {
  prodGridTitle: string = this.translate.instant('audit_log.grid_title');
  prodGridColumns: DipColumn[] = [
    DipColumn.get({property: 'id', type: ProdGridColumnType.ID}),
    DipColumn.get({property: 'username', type: ProdGridColumnType.STRING}),
    DipColumn.get({property: 'source', type: ProdGridColumnType.STRING}),
    DipColumn.get({property: 'message', type: ProdGridColumnType.STRING, isEnum: true}),
    DipColumn.get({property: 'details', type: ProdGridColumnType.STRING}),
    DipColumn.get({
      property: 'createdAt',
      type: ProdGridColumnType.DATE,
      transform: {
        transform: ProdGridColumnTransforms.DATETIME
      }
    })
  ];

  constructor(protected override changeDetectorRef: ChangeDetectorRef, override prodGridDataService: AuditlogService, private translate: TranslateService) {
    super(changeDetectorRef);
  }
}
